<mat-card class="content-card">
  <div class="header" fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutGap="30px">

    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">

        <!-- #region star-end data, date filters, search -->

        <div fxLayout="column" fxLayoutAlign="flex-end center">
          <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
            <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel"
                           [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
            <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel"
                           [(ngModel)]="table.filters.endFilterDate"></app-date-edit>
            <mat-form-field class="date-filter-field">
              <mat-select placeholder="Date filters" [(ngModel)]="table.filters.dateFilterCols" multiple>
                <mat-option *ngFor="let dateFilter of dateFiltersList" [value]="dateFilter.name">{{dateFilter.header}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="search-field">
              <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                     [(ngModel)]="table.filters.str">
            </mat-form-field>
            <button #searchButton mat-icon-button (click)="onSearch()"
                    [disabled]="startDateFilter.invalid || endDateFilter.invalid">
              <mat-icon>search</mat-icon>
            </button>
            <button mat-icon-button (click)="table.clearFilter()">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </div>

        <div fxLayout="column" fxLayoutAlign="flex-end center">
          <button mat-raised-button color="primary" type="button" (click)="uploadTotalCreations()">Upload Total Creations</button>
        </div>

        <div fxLayout="column" fxLayoutAlign="flex-end center">
          <button mat-raised-button color="primary" type="button" (click)="uploadTotalCancellations()">Upload Total Cancellations</button>
        </div>

        <div fxLayout="column" fxLayoutAlign="flex-end center">
          <button mat-raised-button color="blue" type="button" (click)="uploadTotalTransactions()">Upload Total Transactions</button>
        </div>


        <!-- #endregion star-end data, date filters, search -->

      </div>
    </div>
  </div>
  <app-mat-table-generator #table
                           tableName="ordersTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="editEnabled()"
                           [deleteEnabled]="deleteEnabled()"
                           [multiselectEnabled]="multiselectEnabled()"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           (clearingFilters)="checkAllButton()"
                           [dialogRemoveText]="dialogRemoveText">
  </app-mat-table-generator>
</mat-card>
